import React, { ReactNode, FC, useCallback } from 'react';

import useTranslation from '../../../hooks/useTranslation';
import MainHeaderButton from '../MainHeaderButton';
import getLanguageCode from '../../../utils/language/getLanguageCode';

export interface MainLanguageButtonProps {
  children?: ReactNode;
  /** Callback when the language changes. */
  onLanguageChange: (newLocale: 'fr' | 'en') => void;
}

const MainLanguageButton: FC<MainLanguageButtonProps> = ({ onLanguageChange, ...props }) => {
  const { language } = useTranslation();
  const isCurrentLanguageFrench = () => getLanguageCode(language) === 'fr';
  const nextLanguage = isCurrentLanguageFrench() ? 'en' : 'fr';
  const handleClick = useCallback(() => onLanguageChange && onLanguageChange(nextLanguage), [nextLanguage, onLanguageChange]);

  return (
    <MainHeaderButton
      data-testid="MainLanguageButton"
      {...props}
      onClick={handleClick}
    >
      {nextLanguage}
    </MainHeaderButton>
  );
};

export default MainLanguageButton;
